import "./_we-nav-panel-1.scss";
import { gsap } from 'gsap';
/* 
JS DEPENDECIES: GSAP
*/

	const homePageHeader = $(".home #masthead");
	const pageHeader = $("#masthead");
	var navPanelId = "#we-nav-panel-1";
	var headerHeight = pageHeader.outerHeight();
	var screenHeigth = $(window).innerHeight();
	var wpAdminBar;
	var avilableSpaceBelowHeader = screenHeigth - (headerHeight + wpAdminBar);

	var ssNavLinks = $("ul#primary-menu-small-screen a").not('.sub-menu a');

	if ($("#wpadminbar").length > 0) {
		wpAdminBar = $("#wpadminbar").outerHeight();
	} else {
		wpAdminBar = 0;
	}
		//OPENING ANIM INIT
		var navPanelOpeningAnim = gsap.timeline({
			repeat: 0,
			repeatDelay: 1,
			paused: true,
		});
	//OPENING ANIM SET
	navPanelOpeningAnim.set(".we-below-logo-line", {
		opacity: "0",
		overflow: "hidden",
		height: "0px",
    	minHeight: "auto",
    	margin: "12px"
	});
	navPanelOpeningAnim.set(navPanelId, {
		display: "none",
		top: headerHeight + wpAdminBar,
	});
	navPanelOpeningAnim.set($('body'), {
		overflowY: "hidden",
	});
	navPanelOpeningAnim.set(navPanelId, {
		display: "block",
		//top: headerHeight + wpAdminBar,
	});
	navPanelOpeningAnim.to(navPanelId, {
		duration: 0.0,
		opacity: "1",
	});
	navPanelOpeningAnim.to(
		pageHeader,
		{
			duration: 0.0,
			backgroundColor: "#e9e7d8",
		},
		0
	);
	/* navPanelOpeningAnim.to(
		$(".hamburger-1__line"),
		{
			duration: 0.4,
			backgroundColor: "#fff",
		},
		0
	); */
	/* navPanelOpeningAnim.to(
		$(".branding"),
		{
			duration: 0.4,
			filter: "brightness(0) invert(1)",
		},
		0
	); */
	navPanelOpeningAnim.to(
		$("body"),
		{
			duration: 0.0,
			//backgroundColor: "#000324",
		},
		0
	);

	$(ssNavLinks).each(function (index, element) {
		// element == this
		navPanelOpeningAnim.to($(element), {
			duration: 0.0,
			opacity: "1",
			x: 0,
		});
	});
	//END OPENING ANIM SET

	export function weNavPanel1Open() {
		//PANEL SWITCHER SHOULD CALL THIS FUNCTION
		navPanelOpeningAnim.play();
	}
	export function weNavPanel1Close() {
		//PANEL SWITCHER SHOULD CALL THIS FUNCTION
		navPanelOpeningAnim.reverse();
		$(".menu-item-has-children").removeClass("subMenuIsOpened");
		$(".sub-menu").removeClass("isOpened");
		$(".sub-menu").slideUp(400);
	}
$(function () {
	headerHeight = pageHeader.outerHeight();
	screenHeigth = $(window).innerHeight();
	avilableSpaceBelowHeader = screenHeigth - (headerHeight + wpAdminBar);

	gsap.set(navPanelId, {
		top: headerHeight + wpAdminBar,
	});
	gsap.set(navPanelId, {
		height: avilableSpaceBelowHeader + wpAdminBar,
	});

	$(window).resize(function () {
		headerHeight = pageHeader.outerHeight();
		screenHeigth = $(window).innerHeight();
		avilableSpaceBelowHeader = screenHeigth - (headerHeight + wpAdminBar);

		gsap.set(navPanelId, {
			top: headerHeight + wpAdminBar,
		});
		gsap.set(navPanelId, {
			height: avilableSpaceBelowHeader + wpAdminBar,
		});
	});

	//SUBMENU
	var isSubMenuOpened = false;
	$("#primary-menu-small-screen .menu-item-has-children > a").on('click', function (e) {
		e.preventDefault();
		if($(this).parent().find(".sub-menu").hasClass("isOpened") == false) {
			$(this).parent().addClass("subMenuIsOpened");
			$(this).parent().find(".sub-menu").addClass("isOpened");
			$(this).parent().find(".sub-menu").slideDown(400);
		} else {
			$(this).parent().removeClass("subMenuIsOpened");
			$(this).parent().find(".sub-menu").removeClass("isOpened");
			$(this).parent().find(".sub-menu").slideUp(400);
		}
		
	});

	$("#we-nav-panel-1 a").on("click", function (e) { 
		//e.preventDefault();
		weNavPanel1Close();
		$(".hamburger").removeClass("xfy");
	});
});
